import React from 'react';

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="about-card">
          <div className="section-eyebrow">ABOUT X-TERRA MINING</div>
          <h2 className="section-title">
            Reward-Driven <span className="text-gradient">Blockchain Participation</span>
          </h2>
          <p style={{ fontSize: 17, lineHeight: 1.7, marginBottom: 20 }}>
            The X-Terra Mining Platform is designed to reward active community participation
            through a transparent mining system.
          </p>
          <p style={{ fontSize: 17, lineHeight: 1.7 }}>
            Users activate mining daily and earn XT Tokens according to the platform's
            operational rules — a simple, transparent process built for the long term.
          </p>
        </div>
      </div>
    </section>
  );
}
